import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav", "sidebar", "main"]

  connect() {
    this.adjustPositions()
  }

  adjustPositions() {
    const banner = document.querySelector('#masquerade_banner div')
    if (banner) {
      const bannerHeight = banner.offsetHeight
      this.navTarget.style.top = `${bannerHeight}px`
      this.sidebarTarget.style.top = `${bannerHeight + 64}px`
      this.mainTarget.style.paddingTop = `${bannerHeight + 64}px`
    } else {
      this.navTarget.style.top = '0'
      this.sidebarTarget.style.top = '64px'
      this.mainTarget.style.paddingTop = '64px'
    }
  }
}
